import type {ShooterFlyingBubble} from "js/Elements/ShooterFlyingBubble";
import {makeImage} from "js/utils/makeImage";
import {game} from "js/main";
import {lengthDirX, lengthDirY} from "js/utils/lengthDir";

export class FlyingBombFx {
  private tick = 0;

  private offset = { x: 26, y: -30 }

  private readonly bubble: ShooterFlyingBubble;
  constructor(bubble: ShooterFlyingBubble) {
    this.bubble = bubble;
  }

  public update() {
    this.tick++;

    if (this.tick % 4 === 0) {
      this.spawnParticle();
    }
  }

  private spawnParticle() {
    const image = makeImage(this.bubble.x + this.offset.x, this.bubble.y + this.offset.y, 'spark', 0.5, this.bubble.parent as Phaser.Group);
    image.blendMode = Phaser.blendModes.ADD;

    const angle = game.rnd.between(0, 360);
    const distance = game.rnd.between(20, 40);

    game.tweens.create(image).to({
      alpha: 0,
      x: image.x + lengthDirX(angle, distance, false),
      y: image.y + lengthDirY(angle, distance, false),
    }, game.rnd.between(300, 400), Phaser.Easing.Sinusoidal.Out, true).onComplete.addOnce(() => {
      image.destroy();
    })
  }
}
